// Thin host wrapper — Tournament Pass landing. Public, no tier gate
// (INTEGRATION_PATCH §7). Sika Pro+ gets passes complimentary.
// DOCTRINE: the component never charges — purchase/subscribe NAVIGATE
// only; the verified Paystack callback calls intl_acca_record_pass
// server-side (out of scope here).
import { useNavigate } from "react-router-dom";
import { useUserTier } from "../../auth/useUserTier.ts";
import { tierMeets } from "../../auth/tier-gates.ts";
import { useIntlAccaPass } from "../../intl-acca/useIntlAccaPass.ts";
import { PassLandingPage } from "./PassLandingPage.tsx";

export function IntlAccaPassRoute(): JSX.Element {
  const navigate = useNavigate();
  const { tierCode } = useUserTier();
  const vm = useIntlAccaPass();
  return (
    <PassLandingPage
      loading={vm.loading}
      error={vm.error}
      availableTournaments={vm.availableTournaments}
      userPasses={vm.userPasses}
      complimentaryViaSubscription={tierMeets(tierCode, "sika_pro")}
      onPurchase={() => navigate("/pricing")}
      onSubscribe={() => navigate("/pricing")}
    />
  );
}
